<template>
  <div class="p-5 w-full h-full overflow-scroll scrolling-touch">
    <MDArea class="lg:max-w-2xl" :md="require('raw-loader!../MDs/folders.md').default">
    </MDArea>
    <div class="h-64"></div>

    <!--
    <div class="democanvas">
      <ThankYouCanvas></ThankYouCanvas>
    </div>
    -->
    <!--
    <div class="democanvas">
    </div>
    -->

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
